import React from 'react'
import { NavLink } from 'react-router-dom';

import { removeSpacing } from '../utils/utils'
import { Nav } from '../Styles/index';


const NavLinks = ({ navItems, openNav, location, openInfo, fontStyles, setFilter }) => {

    let navigationLinks;

    if (navItems) {
        let navArray = navItems[0].fields.navigationElements;
        navigationLinks = navArray.map((item, i) => {
            if (item.fields.title) {
                const title = item.fields.title.toLowerCase();
                if (title === 'about') {
                    return <a href="#" key={i} onClick={openInfo}>{title}</a>
                }
                if (title === 'stills') {
                    return <NavLink key={i} id="photo" to="/photo" activeClassName="active">{title}</NavLink>
                }
                return null;
            }
            if (item.fields.titles) {
                const tags = item.fields.titles.split(',');
                return tags.map((tag, j) => {
                    const trimmedHash = removeSpacing(tag.trim());
                    const className = location.hash === `#${trimmedHash}` ? 'active' : '';
                    return <NavLink
                        key={`${i}-${j}`}
                        className={className}
                        onClick={() => setFilter(tag.trim())}
                        to={`/#${trimmedHash}`}>
                        {tag}
                    </NavLink>
                });
            }
            return null;
        })
    }

    return (
        <Nav style={fontStyles}>
            {navigationLinks}
        </Nav>
    )
}

export default NavLinks;